import React from 'react';
import { Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarHalfOutlinedIcon from '@mui/icons-material/StarHalfOutlined';

interface RatingStarsProps {
  rating: number
}

export const RatingStars: React.FC<RatingStarsProps> = ({ rating }) => {
  const fullCount = Math.floor(rating);
  const hasHalf = rating - fullCount > 0;
  const icons: JSX.Element[] = [];

  for (let i = 0; i < fullCount; i++) {
    icons.push(
      <StarIcon
        key={`full-${i}`}
        color="secondary"
        fontSize="small"
        sx={{ mx: '2px' }}
      />
    );
  }

  if (hasHalf) {
    icons.push(
      <StarHalfOutlinedIcon
        key="half"
        color="secondary"
        fontSize="small"
        sx={{ mx: '2px' }}
      />
    );
  }

  return (
    <Box display="flex" alignItems="center">
      {icons}
    </Box>
  );
};
